// Proje Finans Yönetimi (/project-finance-management): proje listesi, Proje
// Bütçe Yönetimi, Bütçe Ekle ve Sözleşme Yönetimi. Kayıtlı değerler (aşamalar,
// bütçe seçenekleri) ve Excel raporu Türkçe kalır.
const projectFinance = {
  page: {
    title: 'Proje Finans Yönetimi',
    subtitle: 'Projelerin bütçesi, giderleri ve sözleşmeleri.',
  },
  stats: {
    total: 'Toplam Proje',
    totalShort: 'Toplam',
    active: 'Devam Ediyor',
    activeShort: 'Aktif',
    passive: 'Tamamlandı',
    passiveShort: 'Pasif',
    starting: 'Başlangıç',
    startingShort: 'Başlangıç',
    share: 'Projelerin %{{percent}}’i',
  },
  toolbar: {
    search: 'Müşteri, proje veya departman ile ara…',
    searchShort: 'Proje ara…',
    phase: 'Proje aşaması',
    groups: {
      all: 'Tümü',
      active: 'Aktif',
      passive: 'Pasif',
      starting: 'Başlangıç',
    },
  },
  phases: {
    starting: 'Başlangıç',
    active: 'Aktif',
    activeOld: 'Aktif (Eski)',
    passive: 'Pasif',
    passiveOld: 'Pasif (Eski)',
  },
  columns: {
    titleShort: 'Başlık (Kısa)',
    customer: 'Müşteri',
    projectPhase: 'Proje Aşaması',
    projectDate: 'Proje Tarihi',
    projectDueDate: 'Proje Bitiş Tarihi',
    firstInvoiceDate: 'İlk Fatura Tarihi',
    paymentFrequency: 'Ödeme Sıklığı',
    projectDepartment: 'Proje Departmanı',
    projectCentersType: 'Proje Merkezi Tipi',
    coordinatorAcademician: 'Koordinatör Akademisyen',
    protocolNumber: 'Protokol Numarası',
    ethicsCommitteeDate: 'Etik Kurul Tarihi',
    ethicsCommitteeNumber: 'Etik Kurul Numarası',
    ethicsCommitteePlace: 'Etik Kurul Yeri',
    sbFirstApprovalDate: 'SB İlk Onay Tarihi',
    sbFirstApprovalNumber: 'SB İlk Onay Numarası',
    sbProjectNumber: 'SB Proje Numarası',
    titleLong: 'Başlık (Uzun)',
  },
  table: {
    listLabel: 'Projeler',
    empty: 'Filtrelere uygun proje bulunamadı',
    rangeOf: '/ {{total}} proje',
    ofTotal: 'toplam {{total}} proje içinden',
    jump: 'Sayfaya git',
  },
  panel: {
    label: 'Seçili proje',
    heading: 'Proje',
    untitled: 'Seçili Proje',
    budget: 'Bütçe',
    contracts: 'Sözleşmeler',
  },
  common: {
    cancel: 'İptal',
    close: 'Kapat',
    clear: 'Temizle',
    choose: 'Lütfen seçiniz',
    loading: 'Yükleniyor…',
  },
  budget: {
    title: 'Proje Bütçe Yönetimi',
    summary: {
      income: 'Toplam Gelir',
      expense: 'Toplam Gider',
      balance: 'Toplam Bakiye',
    },
    from: 'Başlangıç',
    to: 'Bitiş',
    clearRange: 'Tarihleri temizle',
    excel: 'Excel İndir',
    add: 'Yeni Bütçe Ekle',
    incomes: 'Gelirler',
    expenses: 'Giderler',
    count: '{{count}} kayıt',
    noIncome: 'Gelir kaydı bulunamadı',
    noExpense: 'Gider kaydı bulunamadı',
    noDescription: 'Açıklama yok',
    noCategory: 'Kategori yok',
    unknown: 'Belirsiz',
    paid: 'Ödendi',
    unpaid: 'Ödenmedi',
    toggleStatus: 'Durumu değiştir: {{status}}',
    delete: 'Gider kaydını sil',
    deleteTitle: 'Gider kaydı silinsin mi?',
    deleteMessage: '“{{name}}” gider kaydı kalıcı olarak silinecek.',
    thisExpense: 'Bu gider',
    note: 'Giderler: projedeki çalışanların maaş ödemeleri ve diğer ödemeleri ile projeye eklenen bütçe kayıtları. Ödeme durumu ve silme yalnızca bütçe kayıtlarında değiştirilebilir. Tarih aralığı listeyi ve Excel raporunu süzer.',
    columns: {
      date: 'Tarih',
      employee: 'Çalışan',
      description: 'Açıklama',
      category: 'Kategori',
      amount: 'Tutar',
      status: 'Durum',
      actions: 'İşlemler',
    },
    markedPaid: 'Ödeme durumu “Ödendi” olarak güncellendi',
    markedUnpaid: 'Ödeme durumu “Ödenmedi” olarak güncellendi',
    statusError: 'Ödeme durumu güncellenemedi',
    deleted: 'Gider kaydı başarıyla silindi',
    deleteError: 'Gider kaydı silinemedi',
    expenseError: 'Gider bilgileri alınırken bir hata oluştu',
    loadError: 'Bütçe verileri yüklenirken bir hata oluştu',
    excelDone: 'Detaylı Excel raporu başarıyla indirildi!',
    excelError: 'Excel dosyası indirilemedi. Lütfen tekrar deneyin.',
  },
  addBudget: {
    title: 'Bütçe Ekle',
    fields: {
      name: 'Bütçe Adı',
      source: 'Bütçe Kaynak',
      owner: 'Bütçe Sahibi',
      type: 'Bütçe Tipi',
      category: 'Bütçe Kategorisi',
      expenseType: 'Gider Tipi',
      currency: 'Para Birimi',
      vat: 'KDV (%)',
      amount: 'Bütçe Miktarı',
      date: 'Bütçe Tarihi',
      expectedDate: 'Beklenen Ödeme Tarihi',
      paymentStatus: 'Ödeme Durumu',
    },
    namePlaceholder: 'Bütçe adını giriniz',
    required: 'Bu alan zorunludur',
    fillAll: 'Lütfen tüm alanları doldurun.',
    submit: 'Ekle',
    adding: 'Ekleniyor…',
    added: 'Bütçe başarıyla eklendi!',
    error: 'Bütçe eklenirken bir hata oluştu!',
    employeesError: 'Çalışanlar yüklenirken bir hata oluştu!',
  },
  contracts: {
    title: 'Sözleşme Yönetimi',
    drop: 'Sözleşme dosyalarınızı sürükleyin veya seçmek için tıklayın',
    dropHint: 'PDF, Word veya Excel',
    uploading: 'Yükleniyor…',
    list: 'Yüklenmiş Sözleşmeler',
    empty: 'Henüz sözleşme yüklenmemiş',
    open: 'Dosyayı görüntülemek için tıklayın',
    delete: 'Sözleşmeyi Sil',
    deleteTitle: 'Sözleşme silinsin mi?',
    deleteMessage: '“{{name}}” sözleşmesi listeden kaldırılacak.',
    uploaded: '“{{name}}” yüklendi',
    uploadError: 'Sözleşme yükleme hatası',
    deleted: 'Sözleşme başarıyla silindi',
    deleteError: 'Sözleşme silinirken hata oluştu',
  },
  toast: {
    loadError: 'Projeler yüklenirken hata oluştu!',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default projectFinance;
